import { useCallback, useEffect, useState } from "react";
import { isLinkOnline as readIsLinkOnline } from "src/utils/isOnline";

/**
 * OS-level link status for flows that do not depend on API reachability.
 */
export const useIsLinkOnline = () => {
  const [isLinkOnline, setIsLinkOnline] = useState(readIsLinkOnline);

  const syncLinkState = useCallback(() => {
    setIsLinkOnline(readIsLinkOnline());
  }, []);

  useEffect(() => {
    syncLinkState();

    window.addEventListener("online", syncLinkState);
    window.addEventListener("offline", syncLinkState);

    return () => {
      window.removeEventListener("online", syncLinkState);
      window.removeEventListener("offline", syncLinkState);
    };
  }, [syncLinkState]);

  return isLinkOnline;
};
